import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 직원 목록
export const getEmployees = (params) => {  // { roleRange: 'PART' }
  return new Promise((resolve, reject) => {
    http
      .get(`/employees`, { params })
      .then((res) => {
        resolve(res.data.employees);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 직원 등록
export const createEmployee = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/employees`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 직원 수정하기
export const putEmployee = (employeeIdx, data) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/employees/${employeeIdx}`, data)
      .then((res) => {
        toast.success(`"${data.name}"님이 수정 되었습니다.`);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 직원 조회
export const getEmployee = (employeeIdx, params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/employees/${employeeIdx}`, { params })
      .then((res) => {
        resolve(res.data.employee);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 직원 삭제
export const deleteEmployee = (employeeIdx, params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/employees/${employeeIdx}`, params)
      .then((res) => {
        resolve('ok');
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 직원 직급 부여 (등록 / 수정 / 제거)
export const updateEmployeeInGrades = (employeeIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/employees/${employeeIdx}/grades`, body)
      .then((res) => {
        resolve(res.data.employee);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 직원 등록 요청 목록
export const getEmployeeRequest = (companyIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/companies/${companyIdx}/employees/request/list`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 직원 등록 요청 승인
export const approveEmployeeRequest = (user, employeeIdx, isTax = false) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/employees/confirm`, {
        state: 1,
        userIdx: user.idx,
        employeeIdx,
        isTax
      })
      .then((res) => {
        toast.success(`${user.name}님의 직원등록 요청이 승인되었습니다.`);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 직원 등록 요청 취소
export const denieEmployeeRequest = (user, isTax = false) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/employees/confirm`, {
        state: 0,
        userIdx: user.idx,
        isTax
      })
      .then((res) => {
        toast.warning(`${user.name}님의 직원등록 요청이 거절되었습니다.`);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 대표 조회
export const getCEOs = () => {
  return new Promise((resolve, reject) => {
    http
      .get(`/employees/roleType?type=1`)
      .then((res) => {
        resolve(res.data.employees);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 경리 조회
export const getFinanceManagers = () => {
  return new Promise((resolve, reject) => {
    http
      .get(`/employees/roleType?type=2`)
      .then((res) => {
        resolve(res.data.employees);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 직원 프로필 수정 (본인)
export const modifyMyEmployeeProfile = (employeeIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/employees/${employeeIdx}/profile`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 직원 서명 저장
export const createEmployeeSignatures = (fileIdx) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/employees/signatures/files/${fileIdx}`)
      .then((res) => {
        toast.success('서명을 등록하였습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 엑셀 다운로드
export const getEmployeeToExcel = () => {
  return new Promise((resolve, reject) => {
    http
      .post(`/employees/excel`, {}, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getEmployeeSearch = (rangeType = "global", params) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/employees/search/${rangeType}`, { params })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};